// Note: The first file of a module here, must also register the module

import "./error-results.component";
import "./no-results.component";
import "./no-search-results.component";
